import http from "@/http-common";
import filehttp from "@/http-file-common";

class TechnicalMaintenanceService {
  getServiceSpecificationList(): Promise<any> {
    return http.api.post("/getServiceSpecificationList/");
  }

  getTechnicalDocumentList(data: any): Promise<any> {
    return http.api.post("/getTechnicalDocumentList/", data);
  }
  getTechnicalMenuList(): Promise<any>  {
    return http.api.post("/getTechnicalMenuList/");
  }
  getFileByCategory(data: any): Promise<any> {
    return filehttp.api.post("/getFileByCategory/", data);
  }

  // Technical Service
  insertOrUpdateSpecification(data: any): Promise<any> {
    return http.api.post("/insertOrUpdateSpecification/", data);
  }
  
  // Technical Category
  insertTechnicalCategory(data: any): Promise<any> {
    return http.api.post("/insertTechnicalCategory/", data);
  }
  updateTechnicalCategory(data: any): Promise<any> {
    return http.api.post("/updateTechnicalCategory/", data);
  }
  deleteTechnicalCategory(data: any): Promise<any> {
    return http.api.post("/deleteTechnicalCategory/", data);
  }

  // Technical Document
  insertTechnicalDocument(data: any): Promise<any> {
    return http.api.post("/insertTechnicalDocument/", data);
  }
  updateTechnicalDocument(data: any): Promise<any> {
    return http.api.post("/updateTechnicalDocument/", data);
  }
  deleteTechnicalDocument(data: any): Promise<any> {
    return http.api.post("/deleteTechnicalDocument/", data);
  }
  getFileByDocument(data: any): Promise<any> {
    return http.api.post("/getFileByDocument/", data);
  }

  // Common file upload/delete
  manageBucketFile(data: any): Promise<any> {
    return http.api.post("/manageBucketFile/", data);
  }
}
export default new TechnicalMaintenanceService();